import type { GetTweetById200MediaLinksItemProjectInfoEngagementAllOf } from './getTweetById200MediaLinksItemProjectInfoEngagementAllOf';
import type { GetTweetById200MediaLinksItemProjectInfoEngagementAllOfTwo } from './getTweetById200MediaLinksItemProjectInfoEngagementAllOfTwo';

/**
 * 프로젝트 참여 통계
 */
export type GetTweetById200MediaLinksItemProjectInfoEngagement = GetTweetById200MediaLinksItemProjectInfoEngagementAllOf & GetTweetById200MediaLinksItemProjectInfoEngagementAllOfTwo;
